export default "__VITE_ASSET__lmExdBtjnYpNskmFJV_eKw__";